// AdminLayout.js
import React from "react";
import Sidebar from "../components/Sidebar/Sidebar"; // Your Sidebar component
import Navbar from "../components/Navbar/Navbar"; // Your Navbar component
import { Outlet } from "react-router-dom";
import "./AdminLayout.css"; // Import the CSS file

const AdminLayout = () => {
  return (
    <div className="admin-layout">
      <div className="admin-sidebar">
        <Sidebar />
      </div>

      <div className="admin-main">
        {/* Navbar at the top */}
        <Navbar />

        {/* Data table and other components */}
        <div className="admin-data-section">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
